import { Controller, useFormContext } from 'react-hook-form';
import {
  DateTimePicker,
  DateTimePickerProps,
} from 'shared/mui/DatePicker/DateTimePicker/DateTimePicker';
import { parseDateInput } from 'utils/date';

type Props = Pick<DateTimePickerProps, 'label' | 'disabled' | 'minDate' | 'maxDate'> & {
  name: string;
};

export const GatewaysEditPilotSettingsDateTimePicker = ({
  name,
  ...pickerProps
}: Props): JSX.Element => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <DateTimePicker
          {...pickerProps}
          onChange={(value) => field.onChange(parseDateInput(value))}
          sx={{ mb: 3 }}
          value={parseDateInput(field.value)?.getTime() ?? null}
        />
      )}
    />
  );
};
